import { type ContextUsageMetadata } from '@newfront-insurance/ai-api';

import type { UIMessageWithMetadata } from '../../../lib/types';

export interface ContextUsageSummary {
  messageId: string;
  progressPercentage: number;
}

export function getContextUsageSummary(messages: UIMessageWithMetadata[]): ContextUsageSummary | null {
  const latest = getLatestContextUsage(messages);
  if (!latest) return null;

  const { budgetTokens, usedTokens } = latest.metadata;
  if (budgetTokens <= 0) return null;

  const usedRatio = usedTokens / budgetTokens;
  const progressPercentage = Math.min(100, Math.max(0, Math.round(usedRatio * 100)));

  return {
    messageId: latest.messageId,
    progressPercentage,
  };
}

function getLatestContextUsage(messages: UIMessageWithMetadata[]): {
  messageId: string;
  metadata: ContextUsageMetadata;
} | null {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const message = messages[i];
    if (message.role === 'assistant' && message.metadata?.contextUsage) {
      return { messageId: message.id, metadata: message.metadata.contextUsage };
    }
  }
  return null;
}
